const {
    IS_LOADING,
    SERIES_MANAGER_LIST_SUCCESS,
    SERIES_MANAGER_LIST_ERROR,
    SERIES_MANAGER_UPDATE_SUCCESS,
    SERIES_MANAGER_UPDATE_ERROR,
    SERIES_MANAGER_FILTER_SUCCESS,
    SERIES_MANAGER_FILTER_ERROR,
    SERIES_MANAGER_FILTER_LIST_SUCCESS,
    SERIES_MANAGER_FILTER_LIST_ERROR
} = require("../actions/Type");

const initialState = {
    series_manager_list: {},
    series_manager_edit: {},
    loading: false,
    series_manager_filter_list: {}
};

export const SeriesManagerReducers = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case SERIES_MANAGER_LIST_SUCCESS:
            return {
                ...state,
                series_manager_list: payload,
                loading: false,
            };
        case SERIES_MANAGER_LIST_ERROR:
            return {
                ...state,
                series_manager_list: payload,
                loading: false,
            };

        case SERIES_MANAGER_FILTER_LIST_SUCCESS:
            return {
                ...state,
                series_manager_filter_list: payload,
                loading: false,
            };
        case SERIES_MANAGER_FILTER_LIST_ERROR:
            return {
                ...state,
                series_manager_filter_list: payload,
                loading: false,
            };

        case SERIES_MANAGER_UPDATE_SUCCESS:
            return {
                ...state,
                series_manager_edit: payload,
                loading: false,
            };
        case SERIES_MANAGER_UPDATE_ERROR:
            return {
                ...state,
                series_manager_edit: payload,
                loading: false,
            };

        case SERIES_MANAGER_FILTER_SUCCESS:
            return {
                ...state,
                series_manager_list: payload,
                loading: false,
            };
        case SERIES_MANAGER_FILTER_ERROR:
            return {
                ...state,
                series_manager_list: payload,
                loading: false,
            };
        default:
            return state;
    }
};
